import React from "react";
import { Link } from "react-router-dom";

import Header from "./header";
import FAQ from "./faq";
import Footer from "./footer";

import { FloatButton } from "antd";
import { Offer } from "../utils/API";
import AdPage from "./AdPage";

const SubPageTemplate: React.FC<{
  standard_categories: Offer[];
  title: string;
  detailLinkParams?: {
    source: string;
    brandType?: string;
  };
}> = ({ standard_categories, title, detailLinkParams }) => {
  return (
    <>
      <div className="relative w-full h-full flex flex-col justify-between bg-red-500">
        <Header />

        <AdPage />

        <main className="flex-1 w-full max-w-[1300px] mx-auto bg-red-500 h-auto">
          <div className="h-auto mx-auto">
            <div className="flex items-center justify-center">
              <div className="absolute z-0 top-[56px] md:top-[70px] w-full max-w-[1200px] mx-auto min-h-[265px] h-[244px] md:h-[400px]">
                <img
                  src="/images/coupon-home-pc.png"
                  alt=""
                  className="w-full h-full object-contain opacity-70"
                  loading="lazy"
                  decoding="async"
                  fetch-priority="auto"
                  referrerPolicy="no-referrer"
                  crossOrigin="anonymous"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
            <div className="w-full relative z-1 mt-[100px] md:mt-[200px] h-auto px-4">
              <h1
                className="w-full text-center text-2xl font-black leading-6 text-white md:text-3xl md:leading-10 mb-6 md:mb-10 md:text-left px-3.5 md:px-[50px]"
                style={{ textShadow: "0px 4px 1px rgba(50, 0, 0, 0.3)" }}
              >
                {title} Coupons
              </h1>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 md:px-[76px] px-6">
                {standard_categories?.map((item) => {
                  const logoUrl = (item.brand_logo || "")
                    .replace("[size]", "200")
                    .replace("[format]", "png");
                  const detailParams = new URLSearchParams({
                    offer_id: item.offer_id,
                    store: item.store,
                  });
                  if (detailLinkParams?.source) {
                    detailParams.set("source", detailLinkParams.source);
                  }
                  if (detailLinkParams?.brandType) {
                    detailParams.set("brand_type", detailLinkParams.brandType);
                  }
                  return (
                    <Link
                      to={`/branddiscountcode?${detailParams.toString()}`}
                      key={item.offer_id}
                      target="_top"
                      rel="noopener noreferrer"
                    >
                      <div className="cursor-pointer py-5 pl-4 md:py-[24px] md:pl-[30px] min-h-[90px] pr-2 flex items-center shadow-card bg-white/90 border-2 border-white rounded-[10px] relative overflow-hidden transition-all duration-200 hover:scale-[1.02] shadow-lg hover:shadow-xl">
                        <div className="flex items-start gap-3 flex-1 min-w-0 mr-2 md:mr-3">
                          <div className="rounded-[10px] bg-white border border-[#fb7401] md:border-[1.5px] md:rounded-lg flex-center">
                            {/* referrerPolicy="no-referrer"
                                crossOrigin="anonymous"
                                fetch-priority="auto" */}
                            <img
                              src={logoUrl}
                              alt={item.merchant_name || item.title || "brand logo"}
                              loading="lazy"
                              decoding="async"
                              width="60"
                              height="60"
                              onError={(e) => {
                                const target = e.currentTarget;
                                if (target.src.endsWith("/images/white.png"))
                                  return;
                                target.src = "/images/white.png";
                              }}
                              className="w-[70px] h-[70px] md:w-[100px] md:h-[100px] rounded-[10px] md:rounded-lg object-contain px-1"
                            />
                          </div>
                          <div className="flex flex-col flex-1 min-w-0 gap-1 md:gap-1.5 overflow-hidden">
                            <div className="w-full min-w-0 overflow-hidden break-words font-bold text-base leading-5 md:text-xl md:leading-7 text-[#130300] line-clamp-1 md:line-clamp-2 md:min-h-[3.5rem]">
                              {item.merchant_name || item.title}
                            </div>
                            <div className="w-full min-w-0 overflow-hidden break-words text-sm md:text-base font-semibold leading-4 md:leading-6 text-[#fb7401] line-clamp-1">
                              {item.label}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
              <FAQ />
            </div>
          </div>
        </main>

        <Footer />
      </div>

      <FloatButton.BackTop />
    </>
  );
};

export default SubPageTemplate;
